<template>
  <div class="tip-toggle">
    <div v-if="showTitle" class="tip-toggle__button" @click="onToggle">
      <div class="tip-toggle__button__text">
        {{ title }}
      </div>
      <ToggleArrowIcon class="ml-4" :is-expanded="isExpanded" />
    </div>

    <SlideUpDown
      timing-function="ease-out"
      :duration="250"
      :active="isExpanded"
    >
      <div class="tip-toggle__content">
        <NoteBox color="blue">
          <slot />
        </NoteBox>
      </div>
    </SlideUpDown>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'
import NoteBox from '@/components/NoteBox'
import ToggleArrowIcon from '@/components/ToggleArrowIcon'

export default {
  name: 'TipToggle',
  components: {
    ToggleArrowIcon,
    SlideUpDown,
    NoteBox
  },
  props: {
    expanded: Boolean,
    showTitle: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Tips'
    }
  },
  data() {
    return {
      isExpanded: this.expanded
    }
  },
  methods: {
    onToggle() {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style lang="scss">
.tip-toggle {
  &__button {
    display: flex;
    align-items: center;
    cursor: pointer;

    &__text {
      color: $blue-900;
      font-weight: 500;
    }
  }

  &__content {
    padding-top: 0.8rem;
    padding-bottom: 0.4rem;
  }
}
</style>
